"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var zen_observable_1 = tslib_1.__importDefault(require("zen-observable"));
exports.Observable = zen_observable_1.default;
//# sourceMappingURL=zenObservable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-link/~/zen-observable-ts/lib/zenObservable.js
// module id = 322
// module chunks = 0